import { render } from "./Rule.vue?vue&type=template&id=a82c7cb0&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"

import "@/assets/css/style_parts.css?vue&type=style&index=0&id=a82c7cb0&lang=css&scoped=true"
import "@/assets/css/style_ranking.css?vue&type=style&index=1&id=a82c7cb0&lang=css&scoped=true"
import "@/assets/css/style_select.css?vue&type=style&index=2&id=a82c7cb0&lang=css&scoped=true"
import "./Rule.vue?vue&type=style&index=3&id=a82c7cb0&scoped=true&lang=css"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82c7cb0"]])

export default __exports__